import { theme } from '@features/lci-report/domain/theme';
import { TextProps } from '@features/powerpoint';

export const periodMarker: TextProps[] = [
  {
    text: 'Training Period',
    options: {
      bold: true,
      color: theme.colors.white,
      fill: { color: '#666666' },
      fontSize: 14,
      h: 0.37,
      w: 2.97,
      x: 0.85,
      y: 6.55,
    },
  },
  {
    text: 'Exposure Period',
    options: {
      bold: true,
      color: theme.colors.black,
      fill: { color: '#CCCCCC' },
      fontSize: 14,
      h: 0.37,
      w: 8.74,
      x: 3.82,
      y: 6.55,
    },
  },
];
